// extracted by mini-css-extract-plugin
module.exports = {"main":"index-module--main--KgH54","image":"index-module--image--2WgC0","brochure":"index-module--brochure--35Jx-","sidebar":"index-module--sidebar--k_rHw"};